import { AdvanceSearchUserDetails } from './advance-search-operation';

export const getCleanUserDetailsValuesOperation = (
  userDetails?: AdvanceSearchUserDetails,
): AdvanceSearchUserDetails | undefined => {
  // If userDetails is undefined, return undefined
  if (!userDetails) return undefined;

  // Create a new object to hold non-empty fields
  const cleanedDetails: AdvanceSearchUserDetails = {};
  let hasValues = false;

  // Check each field and only include non-empty values
  if (userDetails.firstName?.trim()) {
    cleanedDetails.firstName = userDetails.firstName.trim();
    hasValues = true;
  }

  if (userDetails.lastName?.trim()) {
    cleanedDetails.lastName = userDetails.lastName.trim();
    hasValues = true;
  }

  if (userDetails.nationalId?.trim()) {
    cleanedDetails.nationalId = userDetails.nationalId.trim();
    hasValues = true;
  }

  if (userDetails.mail?.trim()) {
    cleanedDetails.mail = userDetails.mail.trim();
    hasValues = true;
  }

  if (userDetails.phoneNumber?.trim()) {
    cleanedDetails.phoneNumber = userDetails.phoneNumber.trim();
    hasValues = true;
  }

  // Only return the object if it has at least one non-empty value
  return hasValues ? cleanedDetails : undefined;
};
